import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handlePending, handleRejected } from '../../common/extra-reducers/commonExtraReducers';
import { getPromptManagerListAPI, createPromptManagerAPI, updatePromptManagerAPI, deletePromptManagerAPI, togglePromptManagerAPI, aiGenerateContentAPI, aiReGenerateContentAPI } from '../../../../services/settings/promptManager';
import { handleFetchPromptManagerList } from './promptManagerExtraReducers';

export const fetchPromptManagerList = createAsyncThunk('promptManager/fetchPromptManagerList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await getPromptManagerListAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const createPromptManager = createAsyncThunk('promptManager/createPromptManager', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await createPromptManagerAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const updatePromptManager = createAsyncThunk('promptManager/updatePromptManager', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await updatePromptManagerAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const deletePromptManager = createAsyncThunk('promptManager/deletePromptManager', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await deletePromptManagerAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const togglePromptManager = createAsyncThunk('promptManager/togglePromptManager', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await togglePromptManagerAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const aiGenerateContent = createAsyncThunk('promptManager/aiGenerateContent', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await aiGenerateContentAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const aiReGenerateContent = createAsyncThunk('promptManager/aiReGenerateContent', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await aiReGenerateContentAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

const promptManagerSlice = createSlice({
  name: 'promptManager',
  initialState: {
    promptManagerList: {},
    currentPage: 1,
    perPage: 1,
    totalPages: 0,
    lastPage: 0,
    totalCount: 0,
    lastUpdate: '',
    status: 'success',
    error: null,
    promptManagerClinicDetails: [],
    aiGeneratedContent: {},
    message: null,
    aiRequestContent: "",
  },
  reducers: {
    setAiRequestContent(state, action) {
      state.aiRequestContent = action.payload;
    },
    clearAiRequestContent(state) {
      state.aiRequestContent = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromptManagerList.pending, handlePending)
      .addCase(fetchPromptManagerList.fulfilled, handleFetchPromptManagerList)
      .addCase(fetchPromptManagerList.rejected, handleRejected)
      .addCase(createPromptManager.pending, handlePending)
      .addCase(createPromptManager.fulfilled, (state, action) => {
        state.status = 'success';
        state.message = action.payload.message || 'Prompt Manager created successfully';
      })
      .addCase(createPromptManager.rejected, handleRejected)
      .addCase(updatePromptManager.pending, handlePending)
      .addCase(updatePromptManager.fulfilled, (state, action) => {
        state.status = 'success';
        state.message = action.payload.message || 'Prompt Manager updated successfully';
      })
      .addCase(updatePromptManager.rejected, handleRejected)
      .addCase(deletePromptManager.pending, handlePending)
      .addCase(deletePromptManager.fulfilled, (state, action) => {
        state.status = 'success';
        state.message = action.payload.message || 'Prompt Manager deleted successfully';
      })
      .addCase(deletePromptManager.rejected, handleRejected)
      .addCase(togglePromptManager.pending, handlePending)
      .addCase(togglePromptManager.fulfilled, (state, action) => {
        state.status = 'success';
        state.message = action.payload.message || 'Prompt Manager status updated successfully';
      })
      .addCase(togglePromptManager.rejected, handleRejected)
      .addCase(aiGenerateContent.pending, handlePending)
      .addCase(aiGenerateContent.fulfilled, (state, action) => {
        console.log("AI Generate Action Payload:", action.payload);
        state.status = 'success';
        state.aiGeneratedContent = action.payload || {};
        state.message = action.payload.message || 'AI content generated successfully';
      })
      .addCase(aiGenerateContent.rejected, handleRejected)
      .addCase(aiReGenerateContent.pending, handlePending)
      .addCase(aiReGenerateContent.fulfilled, (state, action) => {
        console.log("AI Re-Generate Action Payload:", action.payload);
        state.status = 'success';
        state.aiGeneratedContent = action.payload || {};
        state.message = action.payload.message || 'AI content generated successfully';
      })
      .addCase(aiReGenerateContent.rejected, handleRejected);
  },
});

export const { setAiRequestContent, clearAiRequestContent } = promptManagerSlice.actions;

export default promptManagerSlice.reducer;
